var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconPreparationdli30 = function SvgAIconPreparationdli30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H9C7.89543 5 7 5.89543 7 7V22C7 23.1046 7.89543 24 9 24H15M18 5H21C22.1046 5 23 5.89543 23 7V22C23 23.1046 22.1046 24 21 24H15M15 24C15 25.1667 15 28 18 28H20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L23 11",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14L20 14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17L20 17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20L20 20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C18 3.34315 16.6569 2 15 2C13.3431 2 12 3.34315 12 5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0254 5C15.2325 5 15.4004 5.16789 15.4004 5.375C15.4004 5.58211 15.2325 5.75 15.0254 5.75C14.8183 5.75 14.6504 5.58211 14.6504 5.375C14.6504 5.16789 14.8183 5 15.0254 5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconPreparationdli30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMiA1SDlDNy44OTU0MyA1IDcgNS44OTU0MyA3IDdWMjJDNyAyMy4xMDQ2IDcuODk1NDMgMjQgOSAyNEgxNU0xOCA1SDIxQzIyLjEwNDYgNSAyMyA1Ljg5NTQzIDIzIDdWMjJDMjMgMjMuMTA0NiAyMi4xMDQ2IDI0IDIxIDI0SDE1TTE1IDI0QzE1IDI1LjE2NjcgMTUgMjggMTggMjhIMjAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik03IDExTDIzIDExIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTcgMTRMMjAgMTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xNyAxN0wyMCAxNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTE3IDIwTDIwIDIwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTggNUMxOCAzLjM0MzE1IDE2LjY1NjkgMiAxNSAyQzEzLjM0MzEgMiAxMiAzLjM0MzE1IDEyIDUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xNS4wMjU0IDVDMTUuMjMyNSA1IDE1LjQwMDQgNS4xNjc4OSAxNS40MDA0IDUuMzc1QzE1LjQwMDQgNS41ODIxMSAxNS4yMzI1IDUuNzUgMTUuMDI1NCA1Ljc1QzE0LjgxODMgNS43NSAxNC42NTA0IDUuNTgyMTEgMTQuNjUwNCA1LjM3NUMxNC42NTA0IDUuMTY3ODkgMTQuODE4MyA1IDE1LjAyNTQgNSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";